import axios from "axios";

export async function fetchReservation (reservationCode: string) {
  return axios.get(`/api/planner/reservations/${reservationCode}`)
    .then(res => res.data)
}

export async function fetchReservations (page: number, rows: number, searchWord: string, searchPhone: string) {
  return axios.get(`/api/planner/reservations`, {
    params: {
      page,
      rows,
      searchWord,
      searchPhone
    }
  }).then(res => res.data)
}
